'use strict'
import { MarkerClusterer } from "@googlemaps/markerclusterer";
const CLUSTER_ICON_40 = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDBweCIgaGVpZ2h0PSI0MHB4IiB2aWV3Qm94PSIwIDAgNDAgNDAiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigwJSwwJSwwJSk7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlLXdpZHRoOjM7c3Ryb2tlLWxpbmVjYXA6YnV0dDtzdHJva2UtbGluZWpvaW46bWl0ZXI7c3Ryb2tlOnJnYigxMDAlLDEwMCUsMTAwJSk7c3Ryb2tlLW9wYWNpdHk6MTtzdHJva2UtbWl0ZXJsaW1pdDo0OyIgZD0iTSA3OC41IDQwLjUgQyA3OC41IDYyLjA1NTE3NiA2MS4yNDIxODggNzkuNDk3MDcgNDAgNzkuNDk3MDcgQyAxOC43NTc4MTIgNzkuNDk3MDcgMS41IDYyLjA1NTE3NiAxLjUgNDAuNSBDIDEuNSAxOC45NDQ4MjQgMTguNzU3ODEyIDEuNTAyOTMgNDAgMS41MDI5MyBDIDYxLjI0MjE4OCAxLjUwMjkzIDc4LjUgMTguOTQ0ODI0IDc4LjUgNDAuNSBaIE0gNzguNSA0MC41ICIgdHJhbnNmb3JtPSJtYXRyaXgoMC41LDAsMCwwLjQ5MzgyNywwLDApIi8+CjwvZz4KPC9zdmc+Cg=='
const CLUSTER_ICON_80 = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjBweCIgaGVpZ2h0PSI4MHB4IiB2aWV3Qm94PSIwIDAgNjAgNjAiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybztmaWxsOnJnYigwJSwwJSwwJSk7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlLXdpZHRoOjM7c3Ryb2tlLWxpbmVjYXA6YnV0dDtzdHJva2UtbGluZWpvaW46bWl0ZXI7c3Ryb2tlOnJnYigxMDAlLDEwMCUsMTAwJSk7c3Ryb2tlLW9wYWNpdHk6MTtzdHJva2UtbWl0ZXJsaW1pdDo0OyIgZD0iTSAxMTguNSA2MCBDIDExOC41IDkyLjMxMjUgOTIuMzEyNSAxMTguNSA2MCAxMTguNSBDIDI3LjY4NzUgMTE4LjUgMS41IDkyLjMxMjUgMS41IDYwIEMgMS41IDI3LjY4NzUgMjcuNjg3NSAxLjUgNjAgMS41IEMgOTIuMzEyNSAxLjUgMTE4LjUgMjcuNjg3NSAxMTguNSA2MCBaIE0gMTE4LjUgNjAgIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjUsMCwwLDAuNSwwLDApIi8+CjwvZz4KPC9zdmc+Cg==';
const FONT_SIZE_M = "16px";
const FONT_SIZE_S = "14px";
const RANGE_MARKERS_COUNT = 3;

export default function(map, markers) {
    var renderer = {
        render: ({ markers, _position: position }) => {
          return new google.maps.Marker({
            zIndex: 106,
            position: {
              lat: position.lat(),
              lng: position.lng(),
            },
            icon: {
                url: markers.length > RANGE_MARKERS_COUNT ? CLUSTER_ICON_80 : CLUSTER_ICON_40
            },
            label: {
              text: "+" + String(markers.length),
              color: "white",
              fontSize: markers.length > RANGE_MARKERS_COUNT  ? FONT_SIZE_M : FONT_SIZE_S
            }
          });
        },
    };
    
    return new MarkerClusterer({
       map, markers, renderer
    });
};